export class Message {
    MessageHeader = '';
    Text = '';

    constructor(data?: any) {
        this.MessageHeader = data.MessageHeader;
        this.Text = data.Text;
    }
}
